// import { mount } from '@cypress/react';

import { Box, Container } from '@material-ui/core';
import React from 'react';
import styles from './Utilisateurs.module.scss';

type Props = {
    className?: string;
};

const SmallFooter: React.FC<Props> = ({ className }) => {
    return (
        <Box style={{ background: 'white', height: '70px' }} className={className}>
            <Container>
                <Box display={'flex'} className={'mt-2'} justifyContent={'center'} flexDirection={'row'}>
                    <Box className="mt-3">
                        <Box className={styles.textBlue}>SGSanté © 2024</Box>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default SmallFooter;
